import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Banknote, TrendingUp, Home } from 'lucide-react';
import { useAppContext } from '../context/AppContext';

export const WhyChooseUs: React.FC = () => {
  const { city } = useAppContext();
  
  return (
    <section className="py-20 overflow-hidden">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          {/* Left Column - Text Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="space-y-8"
          >
            <div className="max-w-xl">
              <h2 className="mb-8 text-3xl font-bold md:text-4xl">
                {city ? `Perché dovresti usare i nostri servizi a ${city}?` : 'Perché dovresti usare i nostri servizi?'}
              </h2>
              <div className="space-y-8">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex items-center justify-center flex-shrink-0 bg-blue-100 rounded-full w-14 h-14 md:w-16 md:h-16">
                    <TrendingUp className="w-7 h-7 md:w-8 md:h-8 text-[#2563eb]" />
                  </div>
                  <div>
                    <h3 className="mb-2 text-xl font-semibold">Miglior Prezzo di Valutazione</h3>
                    <p className="text-gray-600">
                      {city 
                        ? `Valutiamo la tua auto al miglior prezzo di mercato a ${city}`
                        : 'Valutiamo la tua auto al miglior prezzo di mercato'
                      }
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex items-center justify-center flex-shrink-0 bg-blue-100 rounded-full w-14 h-14 md:w-16 md:h-16">
                    <CheckCircle2 className="w-7 h-7 md:w-8 md:h-8 text-[#2563eb]" />
                  </div>
                  <div >
                    <h3 className="mb-2 text-xl font-semibold">Il Modo Più Facile per Vendere</h3>
                    <p className="text-gray-600">
                      Inserisci i tuoi dettagli e ricevi la valutazione della tua auto online, vendi solo se vuoi
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex items-center justify-center flex-shrink-0 bg-blue-100 rounded-full w-14 h-14 md:w-16 md:h-16">
                    <Banknote className="w-7 h-7 md:w-8 md:h-8 text-[#2563eb]" />
                  </div>
                  <div >
                    <h3 className="mb-2 text-xl font-semibold">Pagamento Immediato</h3>
                    <p className="text-gray-600">
                      La tua auto viene pagata con pagamento immediato (Transferta Bancaria)
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="flex items-start gap-6"
                >
                  <div className="flex items-center justify-center flex-shrink-0 bg-blue-100 rounded-full w-14 h-14 md:w-16 md:h-16">
                    <Home className="w-7 h-7 md:w-8 md:h-8 text-[#2563eb]" />
                  </div>
                  <div >
                    <h3 className="mb-2 text-xl font-semibold">Ritiro Gratuito</h3>
                    <p className="text-gray-600">
                      {city 
                        ? `Raccogliamo la tua auto da casa tua a ${city} a costo zero`
                        : 'Raccogliamo la tua auto da casa tua a costo zero'
                      }
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Images */}
          <div className="relative">
            {/* Accent Image */}
            <motion.img
              initial={{ opacity: 0, y: -50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              src="/img/accent1.png"
              alt="Accent"
              className="absolute right-0 z-10 w-32 -top-10 mix-blend-multiply"
            />
            
            {/* Main Images */}
            <div className="relative grid grid-cols-1 gap-4 md:grid-cols-2">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2 }}
                className="relative h-64 overflow-hidden rounded-lg"
              >
                <img
                  src="/img/why1.jpg"
                  alt="Why Choose Us"
                  className="object-cover w-full h-full transition-transform duration-300 hover:scale-110"
                />
              </motion.div>
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.4 }}
                className="relative h-64 overflow-hidden rounded-lg"
              >
                <img
                  src="/img/why2.jpg"
                  alt="Why Choose Us"
                  className="object-cover w-full h-full transition-transform duration-300 hover:scale-110"
                />
              </motion.div>
      
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}; 